import PropTypes from 'prop-types';
import ODropDownMenu from '../../../UI/DropDownMenu/ODropDownMenu';
import { useTranslation } from 'react-i18next';

const GridOptions = ({
  children,
  handleRadniNalog,
  handlePonuda,
  handleOpenZakljuci,
  disableZakljuci,
  handleRokZavrsetka,
}) => {
  const { t, i18n } = useTranslation();
  const options = [
    {
      title: t('workOrder'),
      subtitle: t('CreatetWorkOrder'),
      path: 'profil',
      id: 1,
      icon: 'fas fa-pen',
      color: '#2f3a3f',
      disabled: localStorage.idFirme !== '1',
      onClick: () => handleRadniNalog(),
    },
    {
      title: t('offer'),
      subtitle: t('createOffer'),
      path: 'profil',
      id: 2,
      icon: 'fas fa-file',
      color: '#2f3a3f',
      disabled: localStorage.idFirme !== '1',
      onClick: () => handlePonuda(),
    },

    {
      title: t('promeniRokZavrsetka'),
      subtitle: t('promeniRokZavrsetka'),
      path: 'profil',
      id: 2,
      icon: 'fas fa-pen',
      color: '#2f3a3f',
      disabled: localStorage.idFirme !== '1',
      onClick: () => handleRokZavrsetka(),
    },
    ...(localStorage.sa === 'true'
      ? [
          {
            title: t('finalize'),
            subtitle: t('finalize'),
            id: 3,
            icon: 'fas fa-check-circle',
            onClick: () => handleOpenZakljuci(),
            disabled: disableZakljuci || localStorage.idFirme !== '1',
          },
        ]
      : []),
  ];

  return (
    <ODropDownMenu align="end" position="anchor" options={options}>
      {children}
    </ODropDownMenu>
  );
};

GridOptions.propTypes = {
  children: PropTypes.node.isRequired,
  handleRadniNalog: PropTypes.func.isRequired,
};

export default GridOptions;
